import { http, toast} from '@/uni_modules/uview-plus'

/**
 * 检查网络是否可用
 */
function isNetworkError() {
	return new Promise(resolve => {
		uni.getNetworkType({
			success: function(res) {
				resolve(res.networkType === 'none')
			},
			fail: function(err) {
				resolve(false)
			}
		})
	})
}

/**
 * 请求统一配置, 我这里接口统一都是post请求，如果你的接口有get或其他等请求需自己改一下
 */
export function httpPost(url, params) {
	return new Promise((resolve, reject) => {
		http.post(url, {
		   "in": params,
		   "app_package": "app_package",
		   "appPackage": "appPackage",
		   "app_sign": "app_sign",
		   "appSign": "appSign",
		   "version": "version",
		   "device": "device",
		   "check_code": "check_code"
		}, {
			// 添加 header 配置
			header: {
				'RUID': params.membId==null?"":params.membId
			}
		}).then(res => {
			// 3.根据自己的接口响应状态码来配置，我这里配置后台给的code大于0代表请求成功
			if (Number(res.data.retCode) > 0) {
				resolve(res.data)
			}else {
				reject(res.data);
			}
		}).catch(err => {
			// 4.检查网络是否可用，返回自己需要抛出的错误
			isNetworkError().then(isNone => {
				reject({
					msg: isNone ? '当前无网络，请检查后重试' : '网络请求失败，请检查后重试'
				});
			})
		})
	})
};

/**
 * 请求统一配置, 我这里接口统一都是post请求，如果你的接口有get或其他等请求需自己改一下
 */
export function httpGet(url, data) {
	return new Promise((resolve, reject) => {
		http.get(url, {
			params: {in: data},
			dataType: 'json'
		}).then(res => {
			// 3.根据自己的接口响应状态码来配置，我这里配置后台给的code大于0代表请求成功
			if (Number(res.data.retCode) > 0) {
				resolve(res.data)
			}else {
				reject(res.data);
			}
		}).catch(err => {
			// 4.检查网络是否可用，返回自己需要抛出的错误
			isNetworkError().then(isNone => {
				reject({
					msg: isNone ? '当前无网络，请检查后重试' : '网络请求失败，请检查后重试'
				});
			})
		})
	})
};